import { motion } from 'framer-motion'

export const animateProps = ({
  delay = 0,
  initialY = 10,
  initial = {},
  animate = {},
  ...rest
} = {}) => ({
  component: motion.div,
  initial: { y: initialY, opacity: 0, ...initial },
  animate: {
    y: 0,
    opacity: 1,
    transition: { delay, duration: 0.3, ease: 'easeOut' },
    ...animate,
  },
  ...rest,
})
